import { render, staticRenderFns } from "./MTextField.vue?vue&type=template&id=47c02c58&scoped=true&"
import script from "./MTextField.vue?vue&type=script&lang=ts&"
export * from "./MTextField.vue?vue&type=script&lang=ts&"
import style0 from "./MTextField.vue?vue&type=style&index=0&id=47c02c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c02c58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
